export enum HubSegmentEnum {
  Main = "Main",
  Personal = "Personal",
}
